import styled from 'styled-components'
import { COLOR, GTR } from '@farewill/ui/tokens'
import { AttachmentIcon } from '@farewill/ui'

export type ActivityType = 'manage_document'

type IconComponentProps = {
  color?: string
  size?: 'S' | 'M' | 'L'
}

const activityIcons: Record<
  ActivityType,
  {
    icon: React.ComponentType<IconComponentProps>
    backgroundColor: string
    fill: string
  }
> = {
  manage_document: {
    icon: AttachmentIcon,
    backgroundColor: '#CC963E',
    fill: COLOR.WHITE,
  },
}

const StyledCircle = styled.div<{
  $backgroundColor: string
}>`
  width: ${GTR.XL};
  height: ${GTR.XL};
  flex-shrink: 0;
  border-radius: 50%;
  margin-right: ${GTR.M};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

type ActivityIconProps = {
  type: ActivityType
  iconFill?: string
  backgroundColor?: string
  className?: string
}

export const ActivityIcon = ({
  type,
  className,
}: ActivityIconProps): React.ReactElement => {
  const { icon: IconComponent, backgroundColor, fill } = activityIcons[type]
  if (!IconComponent) return <></>

  return (
    <StyledCircle $backgroundColor={backgroundColor} className={className}>
      <IconComponent color={fill} size="M" />
    </StyledCircle>
  )
}
